<template lang="pug">
  #page-header
    h1 {{ headerText }}
    SortByMenu(v-bind="$props" v-on="$listeners")
</template>

<script>
export default {
  props: {
    headerText: { type: String, required: true },
    sortOptions: { type: Array, required: true },
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {
    SortByMenu: require('@/components/SortByMenu').default,
  },
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
